import { Checkbox, FormControlLabel } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

export interface FormCheckboxProps {
  name: string;
  placeholder: string;
  control: Control<any>;
  disabled?: boolean;
  autoFocus?: boolean;
}

const FormCheckbox = ({
  name,
  control,
  placeholder,
  autoFocus = false,
  disabled = false,
}: FormCheckboxProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          label={placeholder}
          control={
            <Checkbox
              {...field}
              autoFocus={autoFocus}
              checked={field.value}
              onChange={field.onChange}
              disabled={disabled}
              size='large'
              color='primary'
            />
          }
        />
      )}
    ></Controller>
  );
};

export default FormCheckbox;
